module.exports = __webpack_public_path__ + "static/media/shelli.093118ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shelli.png
// module id = 118
// module chunks = 0